// libraries
import React from 'react'

// components
import LandingPageHero from '/react4xp/components/LandingPageHero'
import SectionDivider from '/react4xp/components/SectionDivider'
import RichTextSection from '/react4xp/components/RichTextSection'

// prop types
export interface LandingPageWrapperProps {
    hero?: {
        bgColor?: string
        invertImagePosition?: boolean
        whiteText?: boolean
        title?: string
        image?: {
            src?: string // 700px x 700px
            srcMedium?: string // 550px x 500px
            alt?: string
        }
        content?: string
    }
    sectionDividers?: {
        top?: boolean
        bottom?: boolean
    }
    mainContent?: string
    region1?: any
    region2?: any
}

export default function LandingPageWrapper({
    hero,
    sectionDividers = {
        top: true,
        bottom: false
    },
    mainContent,
    region1,
    region2
}: LandingPageWrapperProps) {
	return (
		<>
			<LandingPageHero
                bgColor={hero?.bgColor}
				invertImagePosition={hero?.invertImagePosition}
                whiteText={hero?.whiteText}
				title={hero?.title}
				image={hero?.image}
				content={hero?.content}
			/>

			{sectionDividers?.top && <SectionDivider />}

            {region1}

			<RichTextSection content={mainContent} />

            {region2}

            {sectionDividers?.bottom && <SectionDivider />}

		</>
	)
}
